import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css',
})
export class LoaderComponent {
  @Input() loading?: boolean = false; // toggle visibility
  @Input() fullscreen: boolean = true; // fullscreen vs inlines
}
